import { Box, useMediaQuery } from "@material-ui/core";
import React from "react";
import { useTheme } from "@material-ui/styles";
import { headerHeights } from "../config";
import { calculateHeaderHeights } from "../../../utils/calculateHeaderHeights";
import Logo from "./Logo/Logo";

export default function LogoContainer({ appStarted, props }) {
  const isScreenXs = useMediaQuery(useTheme().breakpoints.down("xs"));
  const palette = useTheme().palette;

  const { logo } = headerHeights();

  const boxHeight = calculateHeaderHeights.getLogoContainerHeight(
    isScreenXs,
    appStarted
  );

  const logoHeight = isScreenXs ? logo.mobile : logo.desktop;
  const logoWidth = logoHeight * 1.8;

  return (
    <Box
      className="transition-all"
      height={boxHeight}
      width="100%"
      display="inline-flex"
      style={{ overflow: "hidden", backgroundColor: palette.headerBackground }}
      justifyContent="center"
      mt={0}
      {...props}
    >
      <Box
        position="relative"
        top={8}
        display={"flex"}
        justifyContent={"center"}
      >
        <Logo height={logoHeight} width={logoWidth} />
      </Box>
    </Box>
  );
}
